import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteReceiptDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  merchantName: string;
}

export default function DeleteReceiptDialog({
  open,
  onConfirm,
  onCancel,
  merchantName
}: DeleteReceiptDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Receipt?</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the receipt from <strong>{merchantName}</strong>?
            This action cannot be undone and will update your financial summaries.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
